module.exports = __webpack_public_path__ + "static/media/CryingBaby.26182192.jpg";